import { Record } from 'immutable';

import { Integration } from './Integration';

class Source extends Record(
  {
    id: null,
    customFields: null,
    dataRetentionDays: null,
    externalId: null,
    integrationId: null,
    organizationId: null,
    organizationName: null,
    syncOffsetMinutes: null,
    syncLookBackDate: null,
    sourceStatus: null,
    sourceIsActive: null,
    sourceData: null,
    lastSync: null,
    nextSync: null,
    createdAt: null,
    createdBy: null,
    updatedAt: null,
    updatedBy: null,
    deletedAt: null,
    deletedBy: null,
    integration: null
  },
  'Source'
) {
  constructor(props) {
    super({
      ...props,
      integration: new Integration(props.integration)
    });
  }
}

export { Source };
